/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as ShortGuide from './trans-website-modiface-shortguide';
export * as Guide from './trans-website-modiface-guide';
export * as Errors from './trans-website-modiface-errors';

export const TryItOn = 'Website.Modiface.TryItOn';
export const FindYourNuance = 'Website.Modiface.FindYourNuance';
export const TryProduct = 'Website.Modiface.TryProduct';
export const Colors = 'Website.Modiface.Colors';
export const ChooseAndClose = 'Website.Modiface.ChooseAndClose';
export const SaveImage = 'Website.Modiface.SaveImage';
export const CameraButtonText = 'Website.Modiface.CameraButtonText';
export const UploadButtonText = 'Website.Modiface.UploadButtonText';
export const Loading = 'Website.Modiface.Loading';
export const ActivateCamera = 'Website.Modiface.ActivateCamera';
export const GuideLetsDoIt = 'Website.Modiface.GuideLetsDoIt';
export const GuideNext = 'Website.Modiface.GuideNext';
export const GuideText = 'Website.Modiface.GuideText';
export const Disclaimer = 'Website.Modiface.Disclaimer';
